import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Col, Modal, Row, Table } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import cloneDeep from "lodash.clonedeep";
import { useEventContext } from "../../../context";
import { quizCreate, quizDelete, quizGetByEvent, quizLaunch, quizzesOrderUpdate, quizStop, quizUpdate } from "../../../../api/cp";
import { Event } from "../../Comet";
import Loading from "../../Loading";
import { LinkContainer } from "react-router-bootstrap";
import locale from "../../../locale";
import { PagesProvider } from "../PagesSettings/context/PagesContext";
import QuizzesTableRow from "./QuizzesTableRow";
import QuizResultsModal from "./QuizResultsModal";

const getQuizzesLink = (event, quiz) => {
    const appHost = event?.client?.domain || document.location.hostname;
    let link = `${document.location.protocol}//${appHost}/event/${event.eventKey}`;
    if (quiz && quiz.quizKey) {
        link += '?active-quiz-key=' + quiz.quizKey;
    }

    return link;
}

export const Quizzes = ({ quizzes, onChangeQuiz, onClickCreate, onClickEdit, onClickDelete, onClickLaunch, onClickStop, onDragEnd, isSaving }) => {
    const { event } = useEventContext();

    const [resultsQuiz, setResultsQuiz] = useState(null);

    if (!(quizzes instanceof Array)) {
        return <p>Загрузка списка квизов</p>
    }

    return (
        <>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.interactive')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.quizzes')}</Breadcrumb.Item>
            </Breadcrumb>
            <Row>
                <Col xs={12}>
                    <Button disabled={isSaving} onClick={onClickCreate} bsStyle="success">Создать квиз</Button>
                    {' '}
                    <Button href={getQuizzesLink(event)} target="_blank">Открыть квизы</Button>
                </Col>
            </Row>

            <Table>
                <thead>
                    <tr>
                        <th width={40} />
                        <th width={40}>ID</th>
                        <th>Название</th>
                        <th width={100}>Активен</th>
                        <th width={100}>В списке</th>
                        <th width={150}>Аудитория</th>
                        <th width={200}>Залы</th>
                        <th width={200}>Страницы</th>
                        <th width={200}>Статус</th>
                        <th width={100}></th>
                        <th width={150} />
                        <th width={40} />
                        <th width={40} />
                        <th width={40} />
                    </tr>
                </thead>
                <PagesProvider event={event} setPagesLoaded={() => { }}>
                    <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided) => (
                                <tbody
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                >
                                    {quizzes.map((quiz, index) => (
                                        <Draggable
                                            key={quiz.id}
                                            draggableId={`${quiz.id || index}`}
                                            index={index}
                                        >
                                            {(provided) => (
                                                <tr
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <QuizzesTableRow
                                                        key={quiz.id}
                                                        event={event}
                                                        quizzes={quizzes}
                                                        quiz={quiz}
                                                        onChangeQuiz={onChangeQuiz}
                                                        onClickEdit={onClickEdit}
                                                        onClickDelete={onClickDelete}
                                                        onClickStop={onClickStop}
                                                        onClickLaunch={onClickLaunch}
                                                        onClickShowResult={(id) => setResultsQuiz(id)}
                                                        getQuizzesLink={getQuizzesLink}
                                                        isSaving={isSaving}
                                                    />
                                                </tr>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </tbody>
                            )}
                        </Droppable>
                    </DragDropContext>
                </PagesProvider>
            </Table>

            <Modal show={!!resultsQuiz} onHide={() => setResultsQuiz(null)} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Результаты квиза
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <QuizResultsModal id={resultsQuiz} />
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ({ onEditQuiz }) => {
    const { event } = useEventContext();
    const [quizzes, setQuizzes] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(async () => {
        try {
            const quizzes = await quizGetByEvent(event.eventKey);
            setQuizzes(quizzes.sort((a, b) => a.order - b.order));
        } catch (e) {
            console.error(e);
            setQuizzes(false);
        }
    }, [event]);

    const createQuiz = async () => {
        setIsSaving(true);
        try {
            const quiz = await quizCreate(event.eventKey, { titleRu: 'Новый квиз', titleEn: 'New quiz', backgroundColor: '888888' })
            onEditQuiz(quiz);
        } catch (e) {
            console.error(e);
        }

        setIsSaving(false);
    }

    const saveQuiz = async (quiz, data) => {
        setIsSaving(true);
        const _quiz = { ...cloneDeep(quiz), ...data };
        onQuizUpdate(_quiz);
        try {
            await quizUpdate(quiz.id, data);
        } catch (e) {
            console.error(e);
            onQuizUpdate(quiz);
        }

        setIsSaving(false);
    }

    const deleteQuiz = async (quiz) => {
        setIsSaving(true);

        await quizDelete(quiz.id);
        setQuizzes(quizzes => quizzes.filter(({ id }) => id !== quiz.id));

        setIsSaving(false);
    }

    const onQuizUpdate = (quiz) => {
        setQuizzes((quizzes) => {
            let updated = quizzes.slice();
            const index = quizzes.findIndex(({ id }) => id === quiz.id);
            if (-1 === index) {
                updated.push(quiz);
            } else {
                updated[index] = Object.assign({}, updated[index], quiz);
                // if (!isEqual(updated[index], quiz)) {
                //     updated[index] = Object.assign({}, updated[index], quiz);
                // }
            }
            return updated
        });
    }

    const onQuizDelete = ({ id }) => {
        setQuizzes(quizzes => quizzes.filter((quiz) => quiz.id !== id));
    }

    const onQuizLaunch = async (id) => {
        setIsSaving(true);

        try {
            const response = await quizLaunch(id);
            setQuizzes(quizzes => quizzes.map((quiz) => quiz.id === id ? response : quiz));
        } catch (e) {
            console.log(e)
        }

        setIsSaving(false);
    }

    const onClickStop = async (id) => {
        setIsSaving(true);

        try {
            const response = await quizStop(id);
            setQuizzes(quizzes => quizzes.map((quiz) => quiz.id === id ? response : quiz));
        } catch (e) {
            console.log(e)
        }

        setIsSaving(false);
    }

    const onDragEnd = async (result) => {
        if (!result.destination) {
            return;
        }

        setIsSaving(true);

        let _quizzes = cloneDeep(quizzes);
        const _quizzesCopy = cloneDeep(quizzes);
        const [removed] = _quizzes.splice(result.source.index, 1);
        _quizzes.splice(result.destination.index, 0, removed);
        _quizzes = _quizzes.map((quiz, order) => ({ ...quiz, order }));

        setQuizzes(_quizzes);

        try {
            await quizzesOrderUpdate(event.eventKey, { sortOrder: _quizzes.map(({ id }) => id) });
        } catch (e) {
            console.error(e);
            setQuizzes(_quizzesCopy)
        }

        setIsSaving(false);
    }

    if (null === quizzes) {
        return <Loading>Загрузка списка квизов</Loading>
    }
    if (false === quizzes) {
        return <p>Не удалось загрузить список квизов</p>
    }

    return (
        <>
            <Event event={'create:quiz'} handler={(quiz) => onQuizUpdate(quiz)} />
            <Event event={'update:quiz'} handler={(quiz) => onQuizUpdate(quiz)} />
            <Event event={'delete:quiz'} handler={(quiz) => onQuizDelete(quiz)} />

            <Quizzes
                quizzes={quizzes}
                onChangeQuiz={saveQuiz}
                onClickCreate={createQuiz}
                onClickEdit={onEditQuiz}
                onClickDelete={deleteQuiz}
                onClickLaunch={onQuizLaunch}
                onClickStop={onClickStop}
                onDragEnd={onDragEnd}
                isSaving={isSaving}
            />
        </>
    );
}
